import { SvgIcon, SxProps, Theme } from "@mui/material";

export default function DownloadSvg({ sx }: { sx?: SxProps<Theme> }) {
    return (
        <SvgIcon
            viewBox="0 0 24 24"
            sx={{ width: 24, height: 24, fill: "none", ...sx }}
            data-testid="downloadBtn"
        >
            <g mask="url(#mask0_14790_21678)">
                <path
                    d="M5.99927 20.2163C5.44927 20.2163 4.97843 20.0205 4.58677 19.6288C4.1951 19.2371 3.99927 18.7663 3.99927 18.2163V15.2163H5.99927V18.2163H17.9993V15.2163H19.9993V18.2163C19.9993 18.7663 19.8034 19.2371 19.4118 19.6288C19.0201 20.0205 18.5493 20.2163 17.9993 20.2163H5.99927ZM11.9993 16.2163L6.99927 11.2163L8.39927 9.76631L10.9993 12.3663V4.21631H12.9993V12.3663L15.5993 9.76631L16.9993 11.2163L11.9993 16.2163Z"
                    fill="currentColor"
                />
            </g>
        </SvgIcon>
    );
}
